export const PRODUCT_PRODUCT = 'PRODUCT'
export const PRODUCT_SERVICE = 'SERVICE'

export const Types = [
  {
    code: PRODUCT_PRODUCT,
    label: 'Product'
  },
  {
    code: PRODUCT_SERVICE,
    label: 'Service'
  }
]

export function getLabel (code) {
  return _.get(Types.find((x) => x.code === code), 'label')
}

export default Types



// WEBPACK FOOTER //
// ./src/utils/types/product.js